module.exports = {
  forgot_pwd_url: process.env.REACT_APP_VOYAGER_FORGOT_PWD_URL || "https://voyager.cefc.org.sg/user/change-pw/request"
}